import DatabaseModel from './DatabaseModel.js';
import { unwrapDto } from './responseUtils.js';

// Tarjeta «Domicilio y calendario laboral» de la ficha del empleado (#53).
// Vive en su propio endpoint y no en el de empleados: nada de esto se guarda en EmpleadoMO,
// así que guardar la ficha o sincronizar con SAP no lo puede borrar (I5).
var RhDomicilio = Object.create(DatabaseModel);

RhDomicilio.model = 'rh/domicilio';
RhDomicilio.modelFront = 'rh-domicilio';

// GET /movilidad/rh/domicilio/{username}?anio= → tarjeta + festivos de esa persona
RhDomicilio.get = function (username, anio) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + encodeURIComponent(username)
            + (anio ? '?anio=' + encodeURIComponent(anio) : ''),
        method: 'GET'
    }, false).then(unwrapDto);
};

// PUT /movilidad/rh/domicilio/{username}?anio= → la tarjeta guardada
// El año va aparte de los datos: es el que la pantalla está mirando, y sin él la respuesta vuelve
// con los festivos del año en curso y mueve la cabecera sola.
RhDomicilio.guardar = function (username, data, anio) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + encodeURIComponent(username)
            + (anio ? '?anio=' + encodeURIComponent(anio) : ''),
        method: 'PUT',
        data: data
    }, false).then(unwrapDto);
};

export default RhDomicilio;
